import { Inject, Injectable, Optional } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, TimeoutError } from "rxjs";
import { catchError, timeout } from "rxjs/operators";
import { InjectionToken } from "@angular/core";

export interface TimeoutConfig {
  excludedUrls: string[];
  timeoutValue?: number;
}

export const TIMEOUT_CONFIG = new InjectionToken<TimeoutConfig>("TIMEOUT_CONFIG");


@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
    private readonly timeoutValue: number;
    private readonly excludedUrls: string[];
  
    constructor(@Optional() @Inject(TIMEOUT_CONFIG) config: TimeoutConfig | null) {
      this.timeoutValue = config?.timeoutValue || 10000;
      this.excludedUrls = config?.excludedUrls || ["/api/noOp"];
    }

  private shouldApplyTimeout(url: string): boolean {
    return !this.excludedUrls.some(excludedUrl => url.includes(excludedUrl));
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip timeout for excluded URLs
    if (!this.shouldApplyTimeout(req.url)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      timeout(this.timeoutValue),
      catchError((error) => {
        if (error instanceof TimeoutError) {
          console.error("Request timed out due to bad network connectivity.");
          // Optionally, throw a custom error or return a fallback response
        }
        throw error;
      })
    );
  }
}
